module.exports = __webpack_public_path__ + "media/images/icons/success-bb898e7fa27cf790e21cb5184a8602f8.svg";